export const orderedValues = [
    // PATIENT INFORMATION
    
    "PFName",
    "PLName",
    "PDOB",
    "PDOB1",
    "PPhone",
    "Patient_Phone_Conform",
    "PEmail",
    "Patient_Email_Conform",
    "PAddress1",
    "PCity",
    "PState",
    "PZip",

// REPRESENTATIVE INFORMATION

    "RepAddress1",
    "RepAddress2",
    "RepCity",
    "RepEmail",
    "RepFName",
    "RepLName",
    "RepMName",
    "RepPhone",
    "RepState",
    "RepZip",
    "Rep_Email_Conform",
    "Rep_Phone_Conform",
    
    // INFO TO RELEASE
    
    "infoToReleaseGroup",
    "txtotherrecords",
    "dosto",
    "dosfrom",
    "dosTo1",
    "dosFrom1",
    
    // DISCLOSURE OF SENSITIVE INFORMATION
    
    "sensitiveInfo",
    "excludepsy",
    "excludeSTD",
    "excludeHIV",
    "excludedrug",
    "excludegenetics",

    // FACILTIES AND RECIPIENTS
    
    "facilityOrPhysician",
    "discloseTo",
    "documentation",
    "supportingDocProxy",
    "documentationProxy",
    "facilityList",
    // "inputAuthorizeA",
    // "facilityList",
    
    // "inputAuthorizePhysicianOffices",
    // "inputDisclosePhysicians",
    // "inputPhysicianNames",
    
    "RName",
    "RPhone",
    // "RFax",
    "RAddress1",
    // "RAddress2",
    "RCity",
    "RState",
    "RZip",
    "REmail",
    
    // "Facility",
    // "disclosewhat",
    
    
    // DELIVERY METHOD
    
    // "deliveryMethodGroup",
    "supportingDoc",
    "releasemodePdf"
    
    // MISC
    
    // "todaysDate",
    // "c",
    // "RequestDate",
    // "ArrivedDate",
    // "signdate",
    // "expirationdate",
    // "requesttype",
    // "requesttypeid",
    // "typeofrequestorid",
    // "MedicalAuthNoteResponse",
    // "MedicalAuthNote",
    // "signtime",
    // "FormName",
    // "DupChecked",
    // "proxy",
    // "TargetOrganizationID",
    // "sign",
    // "summary",
    // "verifierStaffName",
    // "PickupCDFacility",
    // "PickupPrintFacility",
    // "OrgState",
    // "supportingDoc",
    // "releasemodePdf",
]